import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'resumeSVG',
}) => {
  const hoverRef = React.createRef();
  const onHoverOn = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('resumeSVG_hover');
  };
  const onHoverOut = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('resumeSVG_hover');
  };
  return (
    <svg
      viewBox="0 0 288 267.5"
      height={height}
      width={width}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={onHoverOn}
      onMouseLeave={onHoverOut}
      ref={hoverRef}
    >
      <path
        d="M192,18.5H38.1V249h211.2V78L192,18.5z M221.9,222.5H65.7v-32.2h156.2V222.5z M221.9,168.9H65.7v-32.2h156.2V168.9z
	 M175.9,93.5l0.4-59.4l57.3,59.5L175.9,93.5z"
      />
    </svg>
  );
};

export default SVG;
